<style scoped>
.this__closeable {
  position: absolute;
  top: 10px;
  right: 12px;
}
</style>
<template>
  <div class="service-bottom-banner" v-if="!isHide">
    <div class="service-bottom-banner__inner">
      <img :src="parsedIcon" v-if="icon" />
      <div class="dash-text__18 dash-text__600 service-bottom-banner-text">
        {{ bannerText }}
      </div>
      <a
        :href="isHref ? buttonAction : null"
        :target="isHref ? '_blank' : null"
      >
        <AuthLockBlock :ym_location="ymLocation">
          <a-button
            class="demo__button demo__button--base"
            @click="!isHref ? buttonAction() : false"
          >
            <span>{{ buttonText }}</span>
            <i class="fa-light fa-chevron-right m-l"></i>
          </a-button>
        </AuthLockBlock>
      </a>
      <div class="this__closeable" v-if="closeable" @click="hide = true">
        <i class="fa-light fa-xmark demo__font--20 demo__color--btnGray"></i>
      </div>
    </div>
    <div class="overload-bg"></div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    icon: {
      type: String,
      required: false,
      default: undefined,
    },
    bannerText: {
      type: String,
      required: true,
    },
    buttonText: {
      type: String,
      required: true,
    },
    buttonAction: {
      type: [Function, String],
      required: true,
    },
    closeable: {
      type: String,
      required: false,
      default: null,
    },
    ymLocation: {
      type: String,
      required: false,
      default: undefined,
    },
  },
  data() {
    return {
      hide: false,
    };
  },
  computed: {
    ...mapGetters(["user"]),
    isHref() {
      return typeof this.buttonAction === "string";
    },
    parsedIcon() {
      return this.icon
        ? require("@/assets/images/" + this.icon + ".svg")
        : undefined;
    },
    isHide() {
      return (
        localStorage.getItem(
          "bottom_banner_" + this.closeable + "_" + (this.user || {}).username
        ) || this.hide
      );
    },
  },
  watch: {
    hide() {
      localStorage.setItem(
        "bottom_banner_" + this.closeable + "_" + (this.user || {}).username,
        true
      );
    },
  },
  created() {
    this.$accessModule("bottom_banner", this);
  },
};
</script>
